import axios from 'axios'
const api = axios

const store = {
    actions: {
        getAllHabitaciones: async ({}, data:any) => {
            try {
                const response = await api.get('/Habitaciones')
                if(response.status === 200) {
                    return response
                }
            } catch (error) {
                return error.response
            }
        },
        getAllHabitacionesHabilitadas: async ({}, data:any) => {
            try {
                const response = await api.get('/Habitaciones/habilitadas')
                if(response.status === 200) {
                    return response
                }
            } catch (error) {
                return error.response
            }
        },
        updateState : async ({},idHabitacion:any) => {
            try{
                const response = await api.put('/Habitaciones/'+idHabitacion)
                if(response.status === 200){
                    return response
                }
            }catch(error ) {
                return error.response
            }
        },
        updateHabitacion : async({}, data :any)=> {
            try{
                const response = await api.patch('/Habitaciones/update/'+data.idHabitacion,data.patchDocument)
                if(response.status === 200){
                    return response
                }
            }catch(error){
                return error.response
            }
        }
    }
}

export default store